import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [setIsOpen] = useState(true);

  const languages = [
    {
      locale: "en",
      title: "English",
      flag: "🇪🇺",
    },
    {
      locale: "ar",
      title: "Arabic",
      flag: "🇦🇪",
    },
  ];

  const changeLanugage = async (e) => {
    const selected = e.target.value;
    await i18n.changeLanguage(selected);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left">
      <select
        value={i18n.language}
        onChange={changeLanugage}
        className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      >
        {languages.map((language) => (
          <option key={language.locale} value={language.locale} className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {language.flag} {language.title}
          </option>
        ))}
      </select>
    </div>
  );
}
